var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customerPage"},[_vm._m(0),_c('customer-list',{attrs:{"list":_vm.customerList,"machine-list":_vm.machineList}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"float-left"})])
}]

export { render, staticRenderFns }